import React, { useState } from "react";
import * as S from "./ModalCriarStyle";
import Loading from "../../Loader";
import { adminService } from "../../../Services/adminService";

// MAPA DE PERMISSÕES CORRIGIDO
const PERMISSIONS_MAP = [
  { key: "admin", label: "Administradores" },
  { key: "client", label: "Clientes" },
  { key: "contract", label: "Contratos" },
  { key: "consultant", label: "Consultores" },
  { key: "contract_validation", label: "Validar Contratos" },
  { key: "withdraw", label: "Saques" },
  { key: "withdraw_validation", label: "Validar Saques" },
  { key: "indication", label: "Indicações" },
  { key: "news", label: "Notícias" },
  { key: "messages", label: "Mensagens" },
  { key: "audit", label: "Auditoria" },
  { key: "data_extract", label: "Extração de Dados" },
  { key: "receiving_accounts", label: "Contas de Depósito" },
];

const createInitialPermissions = () =>
  PERMISSIONS_MAP.reduce((acc, perm) => {
    acc[perm.key] = false;
    return acc;
  }, {});

export default function ModalCriar({ onClose, onUserCreated }) {
  const [userData, setUserData] = useState({
    name: "",
    cpf: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    viewPermissions: createInitialPermissions(),
    editPermissions: createInitialPermissions(),
  });
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
    if (name === "confirmPassword" || name === "password") {
      const otherPassword =
        name === "password" ? userData.confirmPassword : userData.password;
      setPasswordError(
        value !== otherPassword && otherPassword
          ? "As senhas não coincidem."
          : ""
      );
    }
  };

  const handlePermissionToggle = (type, key) => {
    setUserData((prev) => ({
      ...prev,
      [`${type}Permissions`]: {
        ...prev[`${type}Permissions`],
        [key]: !prev[`${type}Permissions`][key],
      },
    }));
  };

  const handleCreate = async () => {
    if (!userData.name || !userData.email || !userData.password) {
      alert("Nome, E-mail e Senha são obrigatórios.");
      return;
    }
    if (userData.password !== userData.confirmPassword) {
      alert("As senhas precisam ser iguais.");
      return;
    }
    setLoading(true);
    try {
      const { confirmPassword, ...payload } = userData;
      await adminService.createAdmin(payload);
      alert("Usuário administrador criado com sucesso!");
      onUserCreated();
    } catch (error) {
      alert(
        `Erro ao criar usuário: ${
          error.response?.data?.message || error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  const isFormInvalid =
    loading ||
    !userData.name ||
    !userData.email ||
    !userData.password ||
    !!passwordError;

  const renderPermissionBox = (type, title) => (
    <S.PermissionsBox>
      <h5>{title}</h5>
      <S.PermissionsList>
        {PERMISSIONS_MAP.map((permission) => (
          <S.PermissionItem
            key={`${type}-${permission.key}`}
            onClick={() => handlePermissionToggle(type, permission.key)}
          >
            <S.Checkbox
              checked={userData[`${type}Permissions`][permission.key]}
            />
            <span>{permission.label}</span>
          </S.PermissionItem>
        ))}
      </S.PermissionsList>
    </S.PermissionsBox>
  );

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
        <Loading load={loading} />
        <S.ModalHeader>
          <h3>Criar Novo Administrador</h3>
          <S.CloseButton onClick={onClose}>&times;</S.CloseButton>
        </S.ModalHeader>
        <S.ModalBody>
          <S.FormGrid>
            <S.InputGroup>
              <label>Nome Completo</label>
              <input
                name="name"
                value={userData.name}
                onChange={handleInputChange}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>CPF</label>
              <input
                name="cpf"
                value={userData.cpf}
                onChange={handleInputChange}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>Email</label>
              <input
                name="email"
                type="email"
                value={userData.email}
                onChange={handleInputChange}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>Telefone</label>
              <input
                name="phoneNumber"
                value={userData.phoneNumber}
                onChange={handleInputChange}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>Senha</label>
              <input
                name="password"
                type="password"
                value={userData.password}
                onChange={handleInputChange}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>Confirmar Senha</label>
              <input
                name="confirmPassword"
                type="password"
                value={userData.confirmPassword}
                onChange={handleInputChange}
              />
              {passwordError && (
                <S.ErrorMessage>{passwordError}</S.ErrorMessage>
              )}
            </S.InputGroup>
          </S.FormGrid>
          <S.PermissionsSectionTitle>
            Definir Permissões
          </S.PermissionsSectionTitle>
          <S.PermissionsGrid>
            {renderPermissionBox("view", "Permissões de Visualização")}
            {renderPermissionBox("edit", "Permissões de Edição")}
          </S.PermissionsGrid>
        </S.ModalBody>
        <S.ModalFooter>
          <S.CancelButton onClick={onClose} disabled={loading}>
            Cancelar
          </S.CancelButton>
          <S.SaveButton onClick={handleCreate} disabled={isFormInvalid}>
            Criar Usuário
          </S.SaveButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
